// 用年级获取颜色
export function getColorByClassNum(classNum) {
  if (classNum === 0) {
    // 托班
    return { select: "#FFD3CC", selected: "#FF7B50" };
  } else if (classNum === 1) {
    // 小班
    return { select: "#C2F698", selected: "#8FCB0A" };
  } else if (classNum === 2) {
    // 中班
    return { select: "#D0F0FF", selected: "#54C4FF" };
  } else if (classNum === 3) {
    // 大班
    return { select: "#ECD0FF", selected: "#FD75FF" };
  }
}

// 学段列表
export const sectionList =
  process.env.NODE_ENV === "production"
    ? [
      {
        id: 0,
        classLevelId: "1392300072581398529",
        classLevelName: "托班上"
      },
      {
        id: 1,
        classLevelId: "1395297226916839425",
        classLevelName: "托班下"
      },
      {
        id: 2,
        classLevelId: "1399610124401053697",
        classLevelName: "小班上"
      },
      {
        id: 3,
        classLevelId: "1399610531709915137",
        classLevelName: "小班下"
      },
      {
        id: 4,
        classLevelId: "1399610945511559169",
        classLevelName: "中班上"
      },
      {
        id: 5,
        classLevelId: "1399611209706573825",
        classLevelName: "中班下"
      },
      {
        id: 6,
        classLevelId: "1399611547276742657",
        classLevelName: "大班上"
      },
      {
        id: 7,
        classLevelId: "1399611774712877058",
        classLevelName: "大班下"
      }
    ]
    : [
      {
        id: 0,
        classLevelId: "100000",
        classLevelName: "托班上"
      },
      {
        id: 1,
        classLevelId: "100001",
        classLevelName: "托班下"
      },
      {
        id: 2,
        classLevelId: "100002",
        classLevelName: "小班上"
      },
      {
        id: 3,
        classLevelId: "100003",
        classLevelName: "小班下"
      },
      {
        id: 4,
        classLevelId: "100004",
        classLevelName: "中班上"
      },
      {
        id: 5,
        classLevelId: "100005",
        classLevelName: "中班下"
      },
      {
        id: 6,
        classLevelId: "100006",
        classLevelName: "大班上"
      },
      {
        id: 7,
        classLevelId: "100007",
        classLevelName: "大班下"
      }
    ];

// 用学段获取颜色 id
export function getColorBySectioId(id) {
  if (id === 0) {
    return { selected: "#FF7A49" };
  } else if (id === 1) {
    return { selected: "#FF6F5B" };
  } else if (id === 2) {
    return { selected: "#8FCB0A" };
  } else if (id === 3) {
    return { selected: "#9DD51F" };
  } else if (id === 4) {
    return { selected: "#54C4FF" };
  } else if (id === 5) {
    return { selected: "#549AFF" };
  } else if (id === 6) {
    return { selected: "#FD75FF" };
  } else if (id === 7) {
    return { selected: "#CF75FF" };
  }
}

// 用学段id获取颜色 classLevelId
export function getColorByClassLevelId(classLevelId) {
  if (process.env.NODE_ENV === "production") {
    if (classLevelId === "1392300072581398529") {
      return { selected: "#FF7A49" };
    } else if (classLevelId === "1395297226916839425") {
      return { selected: "#FF6F5B" };
    } else if (classLevelId === "1399610124401053697") {
      return { selected: "#8FCB0A" };
    } else if (classLevelId === "1399610531709915137") {
      return { selected: "#9DD51F" };
    } else if (classLevelId === "1399610945511559169") {
      return { selected: "#54C4FF" };
    } else if (classLevelId === "1399611209706573825") {
      return { selected: "#549AFF" };
    } else if (classLevelId === "1399611547276742657") {
      return { selected: "#FD75FF" };
    } else if (classLevelId === "1399611774712877058") {
      return { selected: "#CF75FF" };
    }
  } else {
    if (classLevelId === "100000") {
      return { selected: "#FF7A49" };
    } else if (classLevelId === "100001") {
      return { selected: "#FF6F5B" };
    } else if (classLevelId === "100002") {
      return { selected: "#8FCB0A" };
    } else if (classLevelId === "100003") {
      return { selected: "#9DD51F" };
    } else if (classLevelId === "100004") {
      return { selected: "#54C4FF" };
    } else if (classLevelId === "100005") {
      return { selected: "#549AFF" };
    } else if (classLevelId === "100006") {
      return { selected: "#FD75FF" };
    } else if (classLevelId === "100007") {
      return { selected: "#CF75FF" };
    }
  }
}

export const colorArrByIndex = ["#FF6F5B", "#57C500", "#549AFF", "#CF75FF"];
export const borderColorArrByIndex = [
  "#FF6F5B",
  "#8FCB0A",
  "#54C4FF",
  "#FD75FF"
];

export const shadowColorArrByIndex = [
  "#FFE8E5",
  "#DDFAC7",
  "#D2F1FF",
  "#F4E6FF"
];

export function getClassNumByClassLevelId(classLevelId) {
  let classNum = 0;
  if (process.env.NODE_ENV === "production") {
    if (
      classLevelId === "1392300072581398529" ||
      classLevelId === "1395297226916839425"
    ) {
      classNum = 0;
    } else if (
      classLevelId === "1399610124401053697" ||
      classLevelId === "1399610531709915137"
    ) {
      classNum = 1;
    } else if (
      classLevelId === "1399610945511559169" ||
      classLevelId === "1399611209706573825"
    ) {
      classNum = 2;
    } else if (
      classLevelId === "1399611547276742657" ||
      classLevelId === "1399611774712877058"
    ) {
      classNum = 3;
    }
  } else {
    if (classLevelId === "100000" || classLevelId === "100001") {
      classNum = 0;
    } else if (classLevelId === "100002" || classLevelId === "100003") {
      classNum = 1;
    } else if (classLevelId === "100004" || classLevelId === "100005") {
      classNum = 2;
    } else if (classLevelId === "100006" || classLevelId === "100007") {
      classNum = 3;
    }
  }
  return classNum;
}
